import _ from 'lodash'
import {addIdToMap, getCustomId} from '../utils'
import {DATA_TYPES} from '../../../../constants/constants'
import {addNamespaceToStructure} from '../componentDeserializationStructure'
import type {DeserializeComponentParams} from '../types'

export const updateComponentContextsStructure = (deserializationParams: DeserializeComponentParams) => {
    const {compStructure, customId, mappers} = deserializationParams

    const contextsData = compStructure.contexts
    if (!_.isObject(contextsData)) return

    const {oldToNewIdMap} = mappers ?? {oldToNewIdMap: {}}
    deserializationParams.customId = getCustomId(oldToNewIdMap, contextsData, customId)

    const contextsQuery = addNamespaceToStructure(
        deserializationParams,
        contextsData,
        DATA_TYPES.contexts,
        oldToNewIdMap
    )
    if (contextsQuery) {
        compStructure.contextsQuery = contextsQuery
        addIdToMap(contextsData, contextsQuery, oldToNewIdMap)
    }
}
